import React from "react";

const BankDeatils = () => {
  return (
    <div className="pdfpadding bankdeatilspdf">
      <h2>BANK DETAILS :</h2>
      <p>Account name : Keel Info Solution Private Limited</p>
      <p>Account no : 99918514211110</p>
      <p>IFSC code: HDFCOOO8355</p>
    </div>
  );
};

export default BankDeatils;
